import React, { useState } from 'react';
import { DiCssTricks } from 'react-icons/di';
import { MdDelete, MdEdit, MdCheck, MdClose } from 'react-icons/md';
import AddMoreBtn from '../AddMoreBtn';
import { Input } from '../Input/Input';
import classes from './AddMultiValueInputContainer.module.css';

const AddMultiValueInputContainer = ({
  title = 'Default Title',
  inputValue,
  inputSetter,
  arrayValue,
  arraySetter,
  placeholder = 'Enter Text',
  type = 'text',
  subDelete = undefined,
  autoFocus,
  disabled=false,
}) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState('');

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditValue(arrayValue[index]);
  };

  const handleSaveEdit = (index) => {
    if (editValue.trim() !== '') {
      const newArray = [...arrayValue];
      newArray[index] = editValue;
      arraySetter(newArray);
    }
    setEditingIndex(null);
    setEditValue('');
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditValue('');
  };

  const handleDelete = (index) => {
    if (disabled) return;
    if (subDelete !== undefined) {
      subDelete(index);
    } else {
      let newArray = [...arrayValue];
      newArray.splice(index, 1);
      arraySetter(newArray);
    }
  };

  return (
    <div className={classes?.mainContainer}>
      <div
        className={[
          title
            ? classes?.inputAndAddBtnContainer
            : classes?.inputAndAddBtnContainerWithoutTitle,
        ].join(' ')}
      >
        <span className={classes?.titleText}>{title}</span>
        <AddMoreBtn
          onClick={() => {
            if (inputValue !== '') {
              arraySetter((pre) => [...pre, inputValue]);
              inputSetter('');
            }
          }}
          disabled={disabled}
        />
      </div>
      <Input
        autoFocus={autoFocus}
        setter={inputSetter}
        value={inputValue}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
      />
      {arrayValue.map((item, index) => (
        <div
          className={[classes.bulletContainer].join(' ')}
          key={`${index} busHighlight`}
        >
          <DiCssTricks color={'var(--dashboard-main-color)'} size={12} />

          {editingIndex === index ? (
            <>
              <Input
                value={editValue}
                setter={setEditValue}
                placeholder={placeholder}
                type={type}
                autoFocus={true}
                className={classes.editInput}
                parentCustomStyle={{ width: '100%' }}
              />
              <div className={classes.editActions}>
                <MdCheck
                  color={'var(--success-color, #4CAF50)'}
                  size={20}
                  onClick={() => handleSaveEdit(index)}
                  className={classes.actionIcon}
                />
                <MdClose
                  color={'var(--error-color, #f44336)'}
                  size={20}
                  onClick={handleCancelEdit}
                  className={classes.actionIcon}
                />
              </div>
            </>
          ) : (
            <>
              <span>{item}</span>
              <div className={classes.itemActions}>
                {!disabled && (
                  <MdEdit
                    color={'var(--dashboard-main-color)'}
                    size={18}
                    onClick={() => handleEdit(index)}
                    className={classes.actionIcon}
                  />
                )}
                <MdDelete
                  color={'var(--dashboard-main-color)'}
                  size={20}
                  onClick={() => handleDelete(index)}
                  className={classes.actionIcon}
                />
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AddMultiValueInputContainer;
